import { UAParser } from 'ua-parser-js';
import type { SessionBrowser, SessionDevice, SessionOs } from './types';

// Provisional bot rule — pending the unified rule decision tracked in
// tests/fixtures/ua-corpus.json `_meta.is_bot_rule`.
const BOT_RE =
  /bot|crawl|spider|slurp|search|fetcher|preview|monitor|wget|curl|python|java\b|headless|phantom|selenium|playwright/i;

/** UA-derived slice of the session context (ADR-0032). */
export interface UaContext {
  readonly browser: SessionBrowser;
  readonly os: SessionOs;
  readonly device: SessionDevice;
}

/**
 * Parse the user agent once into the shared context shape. Raw parser
 * values, no canonicalization — consumers map to their own enums.
 * Expected outputs for real-world UAs are pinned in
 * tests/fixtures/ua-corpus.json.
 */
export function parseUaContext(ua: string): UaContext {
  const result = new UAParser(ua).getResult();
  return {
    browser: {
      name: result.browser.name || '',
      version: result.browser.version || '',
      engine: result.engine.name || '',
      is_bot: BOT_RE.test(ua),
    },
    os: {
      name: result.os.name || '',
      version: result.os.version || '',
    },
    device: {
      type: result.device.type || 'desktop',
      vendor: result.device.vendor || '',
      model: result.device.model || '',
    },
  };
}
